export { default as DeCookiePolicy } from './DeVersion';
export { default as EnCookiePolicy } from './EnVersion';
export { default as EsCookiePolicy } from './EsVersion';
export { default as FrCookiePolicy } from './FrVersion';
export { default as NlCookiePolicy } from './NlVersion';
